<template>
    <IndexBase @auth="onAuth($event)" action="StatusReport" controller="Report"></IndexBase>

    <Card>
        <template #content>
            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" showGridlines filterDisplay="row" sortMode="multiple" removableSort
                       resizableColumns
                       columnResizeMode="fit"
                       :value="dataModel" 
                       :loading="!dataModel || loading"
                       :paginator="true"
                       :rows="10"
                       :lazy="true"
                       v-model:first="this.start"
                       @state-restore="onStateRestore($event)"
                       @page="onPage($event)"
                       @sort="onSort($event)"
                       @filter="onFilter($event)"
                       v-model:filters="filters"
                       :totalRecords="totalRecords"
                       dataKey="Id" 
                    >
                    <template #header>
                        <div class="p-card-title center mb-5">
                          {{$t('Status_Report')}}
                            <Button  :label="$t('export')" icon="pi pi-print" class="p-button-help p-button-sm" v-if="dataModel" @click="onExport" style="float: right;"/>
                         </div>

                        <div class="p-inputtext-sm p-fluid filters-section">
                            <div class="grid">
                                <div class="col-12">
                                    <div class="grid mb-2 filter-row">
                                        <div class="col-2 filter-label">
                                            <label>Filter Date By</label>
                                        </div>
                                        <div class="col-2 filter-input">
                                           <CustomSelect class="full-width p-inputtext-sm" name="type"
                                                v-model="type"
                                                :url="$API_URL + 'list/lookup'"
                                                :params="{group: this.$LOOKUP_GROUP.FILTER_DATE_BY}"
                                                :minLength="0"
                                                :filter="true"
                                                :placeholder="$t('type')"/>
                                        </div>
                                    </div>

                                    <!-- Row 1: Report Generate Date (label left, inputs right) -->
                                    <div class="grid mb-2 filter-row">
                                        <div class="col-2 filter-label">
                                            <label>{{$t('generate_date_wo')}}</label>
                                        </div>
                                        <div class="col-10 filter-input">
                                            <div class="grid">
                                                <div class="col-6">
                                                    <DatePicker name="From_Date" v-model="From_Date" :placeholder="$t('from_date')"  
                                                        dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" />
                                                </div>
                                                <div class="col-6">
                                                    <DatePicker name="Request_Date" v-model="To_Date" :placeholder="$t('to_date')" 
                                                        dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Row 2: WO Number filter (label left, input + search right) -->
                                    <div class="grid mb-2 filter-row">
                                        <div class="col-2 filter-label">
                                            <label>{{$t('no_wo')}}</label>
                                        </div>
                                        <div class="col-9 filter-input">
                                            <CustomMultiSelect class="full-width p-inputtext-sm" name="listtransacton"
                                                v-model="listtransacton"
                                                :url="$API_URL + 'list/no_wo'"
                                                :params="{}"
                                                :minLength="0"
                                                :filter="true"
                                                :placeholder="$t('no_wo')"/>
                                        </div>
                                        <div class="col-1 flex align-items-center">
                                            <Button icon="pi pi-search" class="p-button-primary p-button-sm" @click="filterDataTable" />
                                        </div>
                                    </div>

                                    <!-- Row 3: View Data (label left, MultiSelect right) -->
                                    <!-- <div class="grid filter-row">
                                        <div class="col-2 filter-label">
                                            <label>{{$t('view_data')}}</label>
                                        </div>
                                        <div class="col-10 filter-input">
                                            <MultiSelect class="full-width p-inputtext-sm" v-model="selectedColumns"
                                                :options="columnOptions"
                                                optionLabel="text"
                                                optionValue="id"
                                                display="chip"
                                                :filter="true"
                                                :placeholder="$t('visible_columns')"
                                                @change="onColumnsChange" />
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </template>
                    
                    <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                        <template #header>
                            <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge"
                            badgeClass="p-badge-danger" />
                        </template>
                        <template #body="slotProps">
                           <p class="center">{{ slotProps.index +=1 }}</p> 
                         </template>
                    </Column>
                
                    <Column v-if="showColumn('No_Wo')" field="No_Wo" :header="$t('no_wo')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('no_wo')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('WO_Type')" field="WO_Type" :header="$t('type')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('type')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('No_SPO')" field="No_SPO" :header="$t('No_SPO')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Link_Main_Wo')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>


                    <Column v-if="showColumn('Created_Date_MainData')" field="Created_Date_MainData" :header="$t('Created_Date_MainData')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_MainData')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_MainData)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('Contractor')" field="Contractor" :header="$t('Contractor')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Contractor')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Type_SPO')" field="Type_SPO" :header="$t('Type_SPO')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Type_SPO')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!-- MC0-->
                    <Column v-if="showColumn('PROCESS_MC0')" field="PROCESS_MC0"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-0</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_MC0')" field="Rev_MC0"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-0</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('MC0_STATUS')" field="MC0_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-0</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('MC0_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_MC0')" field="Pending_MC0"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-0</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!--ADDENDUM MC0-->
                    <Column v-if="showColumn('PROCESS_ADDENDUM_MC0')" field="PROCESS_ADDENDUM_MC0"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Addendum MC-0</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_ADDENDUM_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_BAPVA_MC0')" field="Rev_BAPVA_MC0"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAPVA MC-0</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_BAPVA_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('BAPVA_MC0_STATUS')" field="BAPVA_MC0_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAPVA MC-0</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('BAPVA_MC0_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_BAPVA_MC0')" field="Pending_BAPVA_MC0"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAPVA MC-0</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_BAPVA_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_RKTK_MC0')" field="Rev_RKTK_MC0"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>RKTK MC-0</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_RKTK_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('RKTK_MC0_STATUS')" field="RKTK_MC0_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>RKTK MC-0</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('RKTK_MC0_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_RKTK_MC0')" field="Pending_RKTK_MC0"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>RKTK MC-0</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_RKTK_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>     
                    <Column v-if="showColumn('Rev_ADDENDUM_MC0')" field="Rev_ADDENDUM_MC0"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADDENDUM MC-0</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_ADDENDUM_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('ADDENDUM_MC0_STATUS')" field="ADDENDUM_MC0_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADDENDUM MC-0</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('ADDENDUM_MC0_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_ADDENDUM_MC0')" field="Pending_ADDENDUM_MC0"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADDENDUM MC-0</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_ADDENDUM_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!-- BAIK SPO-->
                    <Column v-if="showColumn('PROCESS_BAIK_SPO')" field="PROCESS_BAIK_SPO"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAIK with SPO</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_BAIK_SPO')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_BAIK_SPO')" field="Rev_BAIK_SPO"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAIK with SPO</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_BAIK_SPO')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('BAIK_SPO_STATUS')" field="BAIK_SPO_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAIK with SPO</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('BAIK_SPO_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_BAIK_SPO')" field="Pending_BAIK_SPO"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAIK with SPO</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_BAIK_SPO')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!-- BAIK-->
                    <Column v-if="showColumn('PROCESS_BAIK')" field="PROCESS_BAIK"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAIK without SPO</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_BAIK')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_BAIK')" field="Rev_BAIK"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAIK without SPO</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_BAIK')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('BAIK_STATUS')" field="BAIK_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAIK without SPO</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('BAIK_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_BAIK')" field="Pending_BAIK"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAIK without SPO</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_BAIK')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <!-- KOM -->
                    <Column v-if="showColumn('PROCESS_KOM')" field="PROCESS_KOM"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KoM</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_KOM')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_KOM')" field="Rev_KOM"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KoM</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_KOM')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('KOM_STATUS')" field="KOM_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KoM</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('KOM_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_KOM')" field="Pending_KOM"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KoM</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_KOM')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!-- MC BETWEEN-->
                    <Column v-if="showColumn('PROCESS_MC_BETWEEN')" field="PROCESS_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-BETWEEN</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_MC_BETWEEN')" field="Rev_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-BETWEEN</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('MC_BETWEEN_STATUS')" field="MC_BETWEEN_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-BETWEEN</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('MC_BETWEEN_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_MC_BETWEEN')" field="Pending_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-BETWEEN</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!--ADDENDUM MC BETWEEN-->
                    <Column v-if="showColumn('PROCESS_ADDENDUM_MC_BETWEEN')" field="PROCESS_ADDENDUM_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Addendum MC-BETWEEN</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_ADDENDUM_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_BAPVA_MC_BETWEEN')" field="Rev_BAPVA_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAPVA MC-BETWEEN</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_BAPVA_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('BAPVA_MC_BETWEEN_STATUS')" field="BAPVA_MC_BETWEEN_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAPVA MC-BETWEEN</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('BAPVA_MC_BETWEEN_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_BAPVA_MC_BETWEEN')" field="Pending_BAPVA_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAPVA MC-BETWEEN</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_BAPVA_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_RKTK_MC_BETWEEN')" field="Rev_RKTK_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>RKTK MC-BETWEEN</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_RKTK_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('RKTK_MC_BETWEEN_STATUS')" field="RKTK_MC_BETWEEN_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>RKTK MC-BETWEEN</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('RKTK_MC_BETWEEN_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_RKTK_MC_BETWEEN')" field="Pending_RKTK_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>RKTK MC-BETWEEN</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_RKTK_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>     
                    <Column v-if="showColumn('Rev_ADDENDUM_MC_BETWEEN')" field="Rev_ADDENDUM_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADDENDUM MC-BETWEEN</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_ADDENDUM_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('ADDENDUM_MC_BETWEEN_STATUS')" field="ADDENDUM_MC_BETWEEN_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADDENDUM MC-BETWEEN</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('ADDENDUM_MC_BETWEEN_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_ADDENDUM_MC_BETWEEN')" field="Pending_ADDENDUM_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADDENDUM MC-BETWEEN</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_ADDENDUM_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!-- PROGRESS TERMIN -->
                    <Column v-if="showColumn('PROCESS_PROGRESS_TERMIN')" field="PROCESS_PROGRESS_TERMIN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Termin</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_PROGRESS_TERMIN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_PROGRESS_TERMIN')" field="Rev_PROGRESS_TERMIN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Termin</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_PROGRESS_TERMIN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('PROGRESS_TERMIN_STATUS')" field="PROGRESS_TERMIN_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Termin</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROGRESS_TERMIN_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_PROGRESS_TERMIN')" field="Pending_PROGRESS_TERMIN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Termin</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_PROGRESS_TERMIN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <!--- DUPLICATE PROGRESS TERMIN -->
                    <Column v-if="showColumn('PROGRESS_TERMIN_DUPLICATE_PROGRESS')" field="PROGRESS_TERMIN_DUPLICATE_PROGRESS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Duplicate Progress Termin</u></div>
                                <div>Number - Latest Progress</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROGRESS_TERMIN_DUPLICATE_PROGRESS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('PROGRESS_TERMIN_DUPLICATE_STATUS')" field="PROGRESS_TERMIN_DUPLICATE_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Duplicate Progress Termin</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROGRESS_TERMIN_DUPLICATE_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_PROGRESS_TERMIN_DUPLICATE')" field="Pending_PROGRESS_TERMIN_DUPLICATE"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Duplicate Progress Termin</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_PROGRESS_TERMIN_DUPLICATE')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!-- BAST TERMIN -->
                    <Column v-if="showColumn('PROCESS_TERMIN')" field="PROCESS_TERMIN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Bast Termin</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_TERMIN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_TERMIN')" field="Rev_TERMIN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Bast Termin</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_BAST_TERMIN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('TERMIN_STATUS')" field="TERMIN_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Bast Termin</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('TERMIN_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_TERMIN')" field="Pending_TERMIN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Bast Termin</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_TERMIN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <!--- DUPLICATE BAST TERMIN -->
                    <Column v-if="showColumn('TERMIN_DUPLICATE_PROGRESS')" field="TERMIN_DUPLICATE_PROGRESS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Duplicate BAST Termin</u></div>
                                <div>Number - Latest Progress</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('TERMIN_DUPLICATE_PROGRESS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('TERMIN_DUPLICATE_STATUS')" field="TERMIN_DUPLICATE_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Duplicate BAST Termin</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('TERMIN_DUPLICATE_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_TERMIN_DUPLICATE')" field="Pending_TERMIN_DUPLICATE"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Duplicate BAST Termin</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_TERMIN_DUPLICATE')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                   <!-- MC100-->
                    <Column v-if="showColumn('PROCESS_MC100')" field="PROCESS_MC100"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-100</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_MC100')" field="Rev_MC100"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-100</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('MC100_STATUS')" field="MC100_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-100</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('MC100_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_MC100')" field="Pending_MC100"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-100</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!--ADDENDUM MC100-->
                    <Column v-if="showColumn('PROCESS_ADDENDUM_MC100')" field="PROCESS_ADDENDUM_MC100"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Addendum MC-100</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_ADDENDUM_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_BAPVA_MC100')" field="Rev_BAPVA_MC100"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAPVA MC-100</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_BAPVA_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('BAPVA_MC100_STATUS')" field="BAPVA_MC100_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAPVA MC-100</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('BAPVA_MC100_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_BAPVA_MC100')" field="Pending_BAPVA_MC100"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAPVA MC-100</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_BAPVA_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_RKTK_MC100')" field="Rev_RKTK_MC100"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>RKTK MC-100</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_RKTK_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('RKTK_MC100_STATUS')" field="RKTK_MC100_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>RKTK MC-100</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('RKTK_MC100_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_RKTK_MC100')" field="Pending_RKTK_MC100"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>RKTK MC-100</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_RKTK_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>     
                    <Column v-if="showColumn('Rev_ADDENDUM_MC100')" field="Rev_ADDENDUM_MC100"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADDENDUM MC-100</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_ADDENDUM_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('ADDENDUM_MC100_STATUS')" field="ADDENDUM_MC100_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADDENDUM MC-100</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('ADDENDUM_MC100_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_ADDENDUM_MC100')" field="Pending_ADDENDUM_MC100"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADDENDUM MC-100</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_ADDENDUM_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!-- KOM QC-->
                    <Column v-if="showColumn('PROCESS_KOM_QC')" field="PROCESS_KOM_QC"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KoM QC</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_KOM_QC')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_KOM_QC')" field="Rev_KOM_QC"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KoM QC</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_KOM_QC')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('KOM_QC_STATUS')" field="KOM_QC_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KoM QC</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('KOM_QC_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!-- QC FINAL -->
                    <Column v-if="showColumn('PROCESS_QC')" field="PROCESS_QC"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Final QC</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_QC')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_QC')" field="Rev_QC"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Final QC</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_QC')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('QC_STATUS')" field="QC_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Final QC</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('QC_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_QC')" field="Pending_QC"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Final QC</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_QC')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    
                    <!-- DELAY -->
                    <Column v-if="showColumn('PROCESS_DELAY')" field="PROCESS_DELAY"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Delay</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_DELAY')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_DELAY')" field="Rev_DELAY"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Delay</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_DELAY')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('DELAY_STATUS')" field="DELAY_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Delay</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('DELAY_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_DELAY')" field="Pending_DELAY"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Delay</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_DELAY')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                     <!-- PENALTY -->
                    <Column v-if="showColumn('PROCESS_PENALTY')" field="PROCESS_PENALTY"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Penalty</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_PENALTY')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_PENALTY')" field="Rev_PENALTY"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Penalty</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_PENALTY')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('PENALTY_STATUS')" field="PENALTY_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Penalty</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PENALTY_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_PENALTY')" field="Pending_PENALTY"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Penalty</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_PENALTY')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>


                    <!-- PROGRESS FINAL -->
                    <Column v-if="showColumn('PROCESS_PROGRESS_FINAL')" field="PROCESS_PROGRESS_FINAL"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Final</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_PROGRESS_FINAL')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_PROGRESS_FINAL')" field="Rev_PROGRESS_FINAL"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Final</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_PROGRESS_FINAL')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('PROGRESS_FINAL_STATUS')" field="PROGRESS_FINAL_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Final</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROGRESS_FINAL_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_PROGRESS_FINAL')" field="Pending_PROGRESS_FINAL"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Final</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_PROGRESS_FINAL')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!-- BAST FINAL -->
                    <Column v-if="showColumn('PROCESS_BAST_FINAL')" field="PROCESS_BAST_FINAL"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Final</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_BAST_FINAL')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_BAST_FINAL')" field="Rev_BAST_FINAL"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Final</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_BAST_FINAL')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('BAST_FINAL_STATUS')" field="BAST_FINAL_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Final</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('BAST_FINAL_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('BAST_FINAL_FINAL')" field="BAST_FINAL_FINAL"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Final</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_BAST_FINAL')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!-- BAST RETENSI -->
                    <Column v-if="showColumn('PROCESS_BAST_RETENSI')" field="PROCESS_BAST_RETENSI"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Retensi</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_BAST_RETENSI')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_BAST_RETENSI')" field="Rev_BAST_RETENSI"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Retensi</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_BAST_RETENSI')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('BAST_RETENSI_STATUS')" field="BAST_RETENSI_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Retensi</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('BAST_RETENSI_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('BAST_RETENSI_FINAL')" field="BAST_RETENSI_FINAL"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Retensi</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_BAST_RETENSI')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <!-- BA ADDENDUM -->
                    <Column v-if="showColumn('PROCESS_ADDENDUM')" field="PROCESS_ADDENDUM"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Addendum</u></div>
                                <div>Process</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PROCESS_ADDENDUM')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_ADDENDUM')" field="Rev_ADDENDUM"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Addendum</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_ADDENDUM')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('ADDENDUM_STATUS')" field="ADDENDUM_STATUS"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Addendum</u></div>
                                <div>Status</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('ADDENDUM_STATUS')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Pending_ADDENDUM')" field="Pending_ADDENDUM"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Addendum</u></div>
                                <div>Pending Approval On</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Pending_ADDENDUM')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>


            </DataTable>
        </template>
    </Card>

   
</template>

<script>
    function getDefaultDates() {
        let fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);
        fromDate.setHours(0, 0, 0, 0);

        let toDate = new Date();
        toDate.setHours(23, 59, 59, 999);

        return { fromDate, toDate };
    }

    export default {
        name: "SummaryReport",
        components: {
        },
        data() {
            const { fromDate, toDate } = getDefaultDates();
            return {
                dataModel: null,
                loading: true,
                totalRecords: 0,
                start: 0,
                stateKey: 'pas-state-summaryreport-' + this.$store.getters.getUsername,
                role: this.$store.getters.getRole,
                isAdmin: this.$store.getters.getIsAdmin,
                isUser: this.$store.getters.getIsUser,
                isTransporter: this.$store.getters.getIsTransporter,
                isDriver: this.$store.getters.getIsDriver,
                sorts: null,
                lazyParams: {},
                filters: null,
                stateFilters: null,
                editorPath: "/ReleaseMatrix/Editor",
                dataUrl: "Report/liststatusreport",
                exportUrl : "report/exportstatusreport",
                canCreate: false,
                canEdit: false,
                canDelete: false,
                canView: false,
                changeval : null,
                From_Date : fromDate,
                To_Date : toDate,
                listtransacton: [],
                header: null,
                type : 'WO Date',
                // column visibility control
                columnOptions: [],
                // list the fields you want visible by default (when user has no saved choice)
                defaultVisibleColumns: ['No_Wo','WO_Type', 'No_SPO', 'Created_Date_MainData', 'Contractor','Type_SPO', 
                                                        
                    'PROCESS_MC0','Rev_MC0','MC0_STATUS','Pending_MC0','PROCESS_ADDENDUM_MC0',
                    'Rev_BAPVA_MC0','BAPVA_MC0_STATUS','Pending_BAPVA_MC0','Rev_RKTK_MC0','RKTK_MC0_STATUS',
                    'Pending_RKTK_MC0','Rev_ADDENDUM_MC0','ADDENDUM_MC0_STATUS','Pending_ADDENDUM_MC0',
                    'PROCESS_BAIK_SPO','Rev_BAIK_SPO','BAIK_SPO_STATUS','Pending_BAIK_SPO','PROCESS_BAIK',
                    'Rev_BAIK','BAIK_STATUS','Pending_BAIK','PROCESS_KOM','Rev_KOM','KOM_STATUS','Pending_KOM',
                    'PROCESS_MC_BETWEEN','Rev_MC_BETWEEN','MC_BETWEEN_STATUS','Pending_MC_BETWEEN',
                    'PROCESS_ADDENDUM_MC_BETWEEN','Rev_BAPVA_MC_BETWEEN','BAPVA_MC_BETWEEN_STATUS',
                    'Pending_BAPVA_MC_BETWEEN','Rev_RKTK_MC_BETWEEN','RKTK_MC_BETWEEN_STATUS','Pending_RKTK_MC_BETWEEN',
                    'Rev_ADDENDUM_MC_BETWEEN','ADDENDUM_MC_BETWEEN_STATUS','Pending_ADDENDUM_MC_BETWEEN',
                    'PROCESS_PROGRESS_TERMIN','Rev_PROGRESS_TERMIN','PROGRESS_TERMIN_STATUS',
                    'Pending_PROGRESS_TERMIN',
                    'PROGRESS_TERMIN_DUPLICATE_PROGRESS','PROGRESS_TERMIN_DUPLICATE_STATUS', 'Pending_PROGRESS_TERMIN_DUPLICATE',
                    'PROCESS_TERMIN','Rev_TERMIN','TERMIN_STATUS','Pending_TERMIN',
                    'TERMIN_DUPLICATE_PROGRESS','TERMIN_DUPLICATE_STATUS', 'Pending_TERMIN_DUPLICATE',
                    'PROCESS_MC100','Rev_MC100','MC100_STATUS','Pending_MC100','PROCESS_ADDENDUM_MC100',
                    'Rev_BAPVA_MC100','BAPVA_MC100_STATUS','Pending_BAPVA_MC100','Rev_RKTK_MC100','RKTK_MC100_STATUS',
                    'Pending_RKTK_MC100','Rev_ADDENDUM_MC100','ADDENDUM_MC100_STATUS','Pending_ADDENDUM_MC100',
                    'PROCESS_KOM_QC','Rev_KOM_QC','KOM_QC_STATUS','PROCESS_QC','Rev_QC','QC_STATUS',
                    'Pending_QC','PROCESS_DELAY','Rev_DELAY','DELAY_STATUS','Pending_DELAY','PROCESS_PENALTY',
                    'Rev_PENALTY','PENALTY_STATUS','Pending_PENALTY','PROCESS_PROGRESS_FINAL','Rev_PROGRESS_FINAL',
                    'PROGRESS_FINAL_STATUS','Pending_PROGRESS_FINAL','PROCESS_BAST_FINAL','Rev_BAST_FINAL',
                    'BAST_FINAL_STATUS','Pending_BAST_FINAL','PROCESS_BAST_RETENSI','Rev_BAST_RETENSI','BAST_RETENSI_STATUS',
                    'Pending_BAST_RETENSI','PROCESS_ADDENDUM','Rev_ADDENDUM','ADDENDUM_STATUS','Pending_ADDENDUM'],
                selectedColumns: [],
                // retry mechanism to wait for DataTable columns to be available
                _columnOptionsRetries: 0,
            }
        },
        methods: {
            onColumnsChange(val){
                // Prevent empty selection: if user unticks all, restore all columns and warn
                if(!this.selectedColumns || this.selectedColumns.length === 0){
                    // restore to all available columns
                    this.selectedColumns = this.columnOptions.map(o=>o.id);
                    if(this.$toast) this.$toast.add({ severity: 'warn', summary: 'Columns', detail: 'At least one column must be visible. Restored all columns.', life: 3000 });
                }
            },
            filterDataTable(){
                this.loadLazyData();
            },
            onChnageIsDeleted(event){
                this.changeval = event;
            },
            onAuth(event) {
                this.canCreate = event.canCreate;
                this.canEdit = event.canEdit;
                this.canDelete = event.canDelete;
                this.canView = event.canView;
            },
            onPage(event) {
                this.start = event.first;
                this.loadLazyData();
            },
            onSort(event) {
                this.sorts = event.multiSortMeta;
                this.loadLazyData();
            },
            onFilter() {
                this.loadLazyData();
            },
            onSelect(event){
                this.selectedRow = event.data;
            },
            onRowExpand(event){
                this.expandedRows = [];
                this.expandedRows.push(event.data);
            },
            editor(mode, id) {
                this.$router.push({ path: this.editorPath, query: { mode: mode, id: id } });
            },
            filter(mode) {
                this.$router.push({ path: this.filterPath, query: { mode: mode} });
            },
            sidebarMessage(event){
                this.$toast.add(event);
            },
            loadLazyData() {
                this.loading = true;
                this.selectedRow = null;
                const { fromDate, toDate } = getDefaultDates();
                if (!this.From_Date) this.From_Date = fromDate;
                if (!this.To_Date) this.To_Date = toDate;
            
                this.lazyParams = {
                    start: this.start,
                    sorts: this.dataSort,
                    filters: this.dataFilter,
                    from_date : this.From_Date,
                    to_date : this.To_Date,
                    type : this.type,
                    listtransacton: this.listtransacton,
                    selectedColumns: this.selectedColumns || []
                };
            
                var self = this;
                this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                    .then((response) => {
                        if (response.data.success) {
                            this.dataModel = response.data.data;
                            // capture header if API returns it in different shapes
                            this.header = response.data.header || (response.data.data && response.data.data.header) || this.header;
                            this.totalRecords = response.data.totalRecords;
                        }
                        else {
                            self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                        //this.$emit('unblock-ui');
                        this.loading = false;
                    })
                    .catch(function (err) {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        //this.$emit('unblock-ui');
                        self.loading = false;
                    });
            },
            setFilters() {
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                for (var i = 0; i < exportable.length; i++) {
                    var filterValue = null;
                    if(this.stateFilters){
                        var field = this.stateFilters[exportable[i].props.field];
                        if(field) filterValue = field.value;
                    }
                    this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
                }
            },
            // build columnOptions from DataTable columns and restore saved selection
            setColumnOptions(){
                try{
                    const cols = (this.$refs.dt && this.$refs.dt.columns) ? this.$refs.dt.columns.filter(c => c.props.field) : [];
                    // If columns are not yet available, retry a few times (DataTable may render after mounted)
                    if((!cols || cols.length===0) && this._columnOptionsRetries < 6){
                        this._columnOptionsRetries++;
                        setTimeout(() => { try{ this.setColumnOptions(); }catch(e){} }, 50);
                        return;
                    }
                    this.columnOptions = cols.map(c => {
                        let header = c.props.header;
                        let text = '';
                        if (header && typeof header === 'string') {
                            text = header;
                        } else {
                            try {
                                const translated = this.$t && this.$t(c.props.field);
                                text = (translated && translated !== c.props.field) ? translated : c.props.field;
                            } catch (e) {
                                text = c.props.field;
                            }
                        }
                        return { id: c.props.field, text };
                    });
                    // apply configured defaults (do NOT persist selection in localStorage)
                    const availableIds = this.columnOptions.map(o=>o.id);
                    const initial = (this.defaultVisibleColumns || []).filter(d => availableIds.includes(d));
                    this.selectedColumns = initial.length ? initial : availableIds;
                }catch(e){
                    // fallback: show all
                    this.columnOptions = [];
                    this.selectedColumns = [];
                }
            },
            showColumn(field){
                if(!this.selectedColumns || this.selectedColumns.length===0) return true;
                return this.selectedColumns.includes(field);
            },
            onStateRestore(event) {
                this.start = event.first;
                this.stateFilters = event.filters;
                this.sorts = event.multiSortMeta;
            },
            editOrder(){
                this.$router.push({ path: this.editorPath, query: { mode: this.$FORM_MODE_EDIT, id: this.selectedRow[0].Id } });
            },
             onModalClose(){
                this.loadLazyData();
            },
            clearFilter(){
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                this.changeval = null;
                
                const { fromDate, toDate } = getDefaultDates();
                this.From_Date = fromDate;
                this.To_Date = toDate;
                this.listtransacton = [];
                this.type = 'WO Date';

                for (var i = 0; i < exportable.length; i++) {
                    var fieldName = exportable[i].props.field;
                    var filterValue = "";
                    if(fieldName.includes("Date") || fieldName.includes("Start_Work") || fieldName.includes("Finish_Work")){
                        filterValue = null;
                    }
                    this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
                }
                // reset selected columns to defaults (or all available if defaults not applicable)
                try{
                    const availableIds = exportable.map(c => c.props.field);
                    const defaults = (this.defaultVisibleColumns || []).filter(d => availableIds.includes(d));
                    this.selectedColumns = defaults.length ? defaults : availableIds;
                }catch(e){}

                this.loadLazyData();
            },
            onExport(){
                this.loading = true;
                this.selectedRow = null;
                const { fromDate, toDate } = getDefaultDates();
                if (!this.From_Date) this.From_Date = fromDate;
                if (!this.To_Date) this.To_Date = toDate;
                if (!this.type) this.type = 'WO Date';

                this.lazyParams = {
                    start: this.start,
                    sorts: this.dataSort,
                    filters: this.dataFilter,
                    from_date : this.From_Date,
                    to_date : this.To_Date,
                    type : this.type,
                    listtransacton: this.listtransacton,
                    selectedColumns: this.selectedColumns || []
                };

                var self = this;

                this.$axios.post(this.$API_URL + this.exportUrl, this.lazyParams, {
                    responseType: 'blob',
                    timeout: this.$AXIOS_TIMEOUT_LONG
                    })
                    .then((response) => {
                        var contentDisposition = response.headers["content-disposition"];
                        var matchName = contentDisposition.match(/filename\s*=\s*"?(.+)"?/);
                        var filename = matchName[1].split(';')[0];
                        
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        
                    })
                    .catch(function (err) {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 60000});
                    })
                    .finally(() => {
                        self.loading = false;
                    });
            }
            ,
            statusProgressStyle(data){
                // prefer per-row indicator in dataModel
                const rowIndicator = data && (data.Indicator_Status_Progress || data.indicator_status_progress || data.IndicatorStatusProgress);
                if (rowIndicator) {
                    return 'background-color: #ffc0cb; color: #000; padding:2px 6px; border-radius:4px; display:inline-block;';
                }
                return '';
            }
        },
        mounted() {
            this.$emit('unblock-ui');
            this.setFilters();
            this.$nextTick(() => {
                try{ this.setColumnOptions(); }catch(e){}
                // Inline fallback to ensure header spacing/styles show regardless of external CSS cascade
                try{
                    const headerEl = document.querySelector('.p-inputtext-sm.p-fluid');
                    if(headerEl){
                        headerEl.style.paddingBottom = '1rem';
                        headerEl.style.marginBottom = '1rem';
                        headerEl.style.borderBottom = '1px solid #eef2f5';
                    }
                }catch(e){}
            });
            this.loadLazyData();
            this.$showToast();
        },
        computed: {
            dataFilter() {
                var h = [];
                if (this.filters) {
                    for (const [key, value] of Object.entries(this.filters)) {
                        h.push({
                            field: key ? key : null,
                            value: value.value,
                            matchMode: value.matchMode
                        });
                    }
                }
                return h;
            },
            dataSort() {
                var h = [];
                if (this.sorts) {
                    for (var x = 0; x < this.sorts.length; x++) {
                        h.push({
                            field: this.sorts[x].field,
                            order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                        });
                    }
                }
                return h;
            },
            filterBadge(){
                var badgeNumber = 0;

                if(this.From_Date!=null) badgeNumber+=1;
                if(this.To_Date!=null) badgeNumber+=1;

                this.dataFilter.filter(function(item) {                    
                    if(item.value){
                        badgeNumber++;
                    }
                });

                return badgeNumber;
            }
        },
    }
</script>

<style scoped>
/* keep minimal overrides if needed */
    .p-card .p-card-content{
        margin:0!important;
        padding: 0 !important;
    }
    .center{
        text-align: center;
    }
    /* make header title centered */
    .p-card-title.center {
        text-align: center;
        width: 100%;
    }
    /* align labels on left and inputs on right */
    .filters-section .filter-row {
        align-items: center;
    }
    .filters-section .filter-label {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 0.75rem;
    }
    .filters-section .filter-input {
        display: flex;
        align-items: center;
    }
    .filters-section .filter-row .p-button {
        margin-left: 0.25rem;
    }
    /* ensure filter section uses full available width */
    .filters-section {
        width: 100%;
        max-width: none;
    }
    /* ensure components with full-width class actually expand */
    .filters-section .full-width {
        width: 100% !important;
    }
    /* ensure header-defined widths apply to body when resizing */
    .p-datatable .p-datatable-table {
        table-layout: fixed;
    }
    .p-datatable .p-datatable-thead th {
        white-space: normal;
    }
    .p-datatable .p-datatable-tbody td {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>